import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2),
		height: `calc(100% - 48px)`,
		maxWidth: "100%", // ✅ Permitir ancho completo sin restricciones
		width: "100%", // ✅ Ancho completo
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
		width: "100%", // ✅ Ancho completo
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer} maxWidth={false}> {/* ✅ maxWidth={false} para permitir ancho completo */}
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
